import { Controller } from 'stimulus';
import Utility from '../classes/Utility';

// To control an element to be "fixed" in its spot as it scrolls
// Note: To imitate the sticky effect
class FixedElementController extends Controller {
  connect() {
    this.offsetTop = parseFloat(this.data.get('offsetTop'));
    this.endAtElementClass = this.data.get('endingElementClass');
    this.supportedDevices = this.data.get('devices');
    if (JSON.parse(this.supportedDevices).includes(Utility.getDeviceType())) {
      this.endingElement = document.querySelector(`.${this.endAtElementClass}`);
      this.element.classList.add('t-sticky');
      this.element.style.top = `${this.offsetTop}px`;
      this.element.parentNode.style.height = `${this.__offsetTop(this.endingElement) - this.__offsetTop(this.element)}px`;
    }
  }

  __offsetTop(element) {
    const { top } = element.getBoundingClientRect()
    const scrollTop = window.scrollY;
    return top + scrollTop;
  }
}

export default FixedElementController;
